import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/camera.svg
 */
const IconCamera: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M23 9.143a.969.969 0 01-.707-.314A1.113 1.113 0 0122 8.072v-.715c0-.852-.317-1.669-.88-2.271A2.906 2.906 0 0019 4.143h-.667a.968.968 0 01-.707-.314 1.11 1.11 0 01-.293-.758c0-.284.105-.557.293-.758A.968.968 0 0118.333 2H19c1.326.002 2.597.567 3.534 1.571C23.472 4.575 24 5.937 24 7.357v.715c0 .14-.026.28-.076.41-.05.13-.124.247-.217.347a.996.996 0 01-.324.233.943.943 0 01-.383.081zM18.333 22H19c1.326-.002 2.597-.567 3.534-1.571.938-1.005 1.465-2.367 1.466-3.787v-.714c0-.284-.106-.557-.293-.758a.966.966 0 00-.707-.313.967.967 0 00-.707.313c-.188.201-.293.474-.293.758v.714a3.345 3.345 0 01-.881 2.27 2.914 2.914 0 01-2.119.945h-.667a.967.967 0 00-.707.314c-.188.2-.293.473-.293.758 0 .284.105.556.293.757.187.2.442.314.707.314zM0 15.928v.714c.001 1.42.529 2.782 1.466 3.787C2.404 21.433 3.674 21.999 5 22h.667c.265 0 .52-.113.707-.314.187-.201.293-.473.293-.758 0-.284-.106-.556-.293-.757a.966.966 0 00-.707-.314H5a2.912 2.912 0 01-2.118-.945A3.346 3.346 0 012 16.642v-.714c0-.284-.106-.557-.293-.758A.966.966 0 001 14.857a.968.968 0 00-.707.313c-.188.201-.293.474-.293.758zM5.667 2.003H5c-1.325.002-2.596.567-3.534 1.57C.53 4.579.002 5.94 0 7.36v.715c0 .284.105.556.293.757A.968.968 0 001 9.146c.265 0 .52-.113.707-.314.187-.201.293-.473.293-.757V7.36c.003-.852.32-1.667.882-2.27A2.912 2.912 0 015 4.147h.667c.265 0 .52-.113.707-.314.187-.2.293-.473.293-.758 0-.284-.106-.557-.293-.758a.966.966 0 00-.707-.313zM12.964 9H7.732C7.328 9 7 9.293 7 9.656v4.688c0 .363.328.656.732.656h5.232c.404 0 .732-.293.732-.655v-4.69c0-.361-.328-.655-.732-.655zM16.147 9.54l-1.936 1.21v2.502l1.936 1.21a.6.6 0 00.56.031.522.522 0 00.214-.18.448.448 0 00.079-.25v-4.12a.449.449 0 00-.077-.253.524.524 0 00-.213-.18.6.6 0 00-.563.03z"
      fill="currentColor"
    />
  </svg>
);

export default IconCamera;
